import { createCanBoundTo } from '@casl/react';
import { ability } from '../helpers/ability';

export default createCanBoundTo(ability);
